import React, {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Spinner, Panel,
} from "CommonComponents/bricks";
import {
  renderChildren,
  withLocation,
} from "CommonCore/router-util";

export default class DashboardWidgetAntragFilter extends Component {
  constructor() {
    super();
  }

  render() {
    const { data, setFilter } = this.props;

    if (!data) {
      return <Spinner />;
    }
    return <Panel className='text-center'><GotoLink setFilter={setFilter} to='/antrag'>
      <h4>{data.label}</h4>
      <h3>{data.wert}</h3>
    </GotoLink></Panel>;
  }
}

@withLocation
export class GotoLink extends React.Component {
  render() {
    return <Button variant='link' onClick={this.navigate}>
      {renderChildren(this.props)}
    </Button>;
  }
  navigate = () => {
    const { setFilter, history, to } = this.props;
    setFilter && setFilter();
    history.push(to);
  };
}

